export const FETCH_PROFILE = 'user/FETCH_PROFILE'
